import React from 'react'
import { Link } from 'react-router-dom'
import { useUserRole } from 'auth'
import { Metrics, userTypes, DropdownLink } from 'shared'

export const CampaignHeader: React.FC<any> = (props: any) => {
  const { campaign } = props
  const role: any = useUserRole()
  const companiesDiscovered =
    campaign?.objective?.results.reduce((a: any, c: any) => a + Number(c.companiesDiscovered), 0) ||
    0
  const meetingsBooked =
    campaign?.objective?.results.reduce((a: any, c: any) => a + Number(c.meetingBooked), 0) || 0

  return (
    <div className='card mb-6 mb-xl-9'>
      <div className='card-body pt-9 pb-0'>
        {/* begin::Details */}
        <div className='d-flex flex-wrap flex-sm-nowrap mb-6'>
          {/*begin::Image*/}
          <div className='d-flex flex-center flex-shrink-0 bg-light rounded w-100px h-100px w-lg-150px h-lg-150px me-7 mb-4'>
            <img
              src={campaign.client?.logoUrl}
              className=''
              alt='Campaign logo'
              style={{ width: '150px', paddingTop: '15px', objectFit: 'contain' }}
            />
          </div>
          {/*end::Image*/}
          {/*begin::Wrapper*/}
          <div className='flex-grow-1'>
            {/*begin::Head*/}
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              {/*begin::Details*/}
              <div className='d-flex flex-column'>
                {/*begin::Status*/}
                <div className='d-flex align-items-center mb-1'>
                  <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-3'>
                    Campaign: {campaign.name}
                  </a>
                  <span className='badge badge-light-success me-auto'>{campaign?.status}</span>
                </div>
                {/*end::Status*/}
                {/*begin::Description*/}
                <div className='d-flex flex-wrap fw-bold mb-4 fs-5 text-gray-400'>
                  {campaign.description}
                </div>
                {/*end::Description*/}
                <div className='d-flex align-items-center mb-1'>
                  <p className='text-gray-700 fs-5 fw-bolder me-3'>
                    Start Date: {campaign?.formattedStartDate}
                  </p>
                  {campaign.formattedEndDate && (
                    <>
                      <p className='text-gray-700 fs-5 fw-bolder me-3'>|</p>
                      <p className='text-gray-700 fs-5 fw-bolder me-3'>
                        End Date: {campaign?.formattedEndDate}
                      </p>
                    </>
                  )}
                </div>
              </div>
              {/*end::Details*/}
              {/*begin::Actions*/}
              <div className='d-flex mb-4'>
                {(role === userTypes.Admin ||
                  role === userTypes.ClientManager ||
                  role === userTypes.CampaignManager) && (
                  <Link
                    to={`/campaign/${campaign.id}/objective/create`}
                    className='btn btn-sm btn-primary me-3'
                  >
                    Add Objective Update
                  </Link>
                )}
              </div>
              {/*end::Actions*/}
            </div>
            {/*end::Head*/}
            {/*begin::Info*/}
            <div className='d-flex flex-wrap justify-content-start'>
              {/*begin::Stats*/}
              <div className='d-flex flex-wrap'>
                {/*begin::Stat*/}
                <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                  {/*begin::Number*/}
                  <div className='d-flex align-items-center'>
                    <div className='fs-4 fw-bolder'>{companiesDiscovered}</div>
                  </div>
                  {/*end::Number*/}
                  {/*begin::Label*/}
                  <div className='fw-bold fs-6 text-gray-400'>{Metrics.campaniesDiscovered}</div>
                  {/*end::Label*/}
                </div>
                {/*end::Stat*/}
                {/*begin::Stat*/}

                {/*end::Stat*/}
                {/*begin::Stat*/}
                <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                  {/*begin::Number*/}
                  <div className='d-flex align-items-center'>
                    <div className='fs-4 fw-bolder'>{meetingsBooked}</div>
                  </div>
                  {/*end::Number*/}
                  {/*begin::Label*/}
                  <div className='fw-bold fs-6 text-gray-400'>{Metrics.meetingsBooked}</div>
                  {/*end::Label*/}
                </div>
                {/*end::Stat*/}
              </div>
              {/*end::Stats*/}
            </div>
            {/*end::Info*/}
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Details*/}
        <div className='separator'></div>
        {/*begin::Nav wrapper*/}

        <div className='d-flex h-55px'>
          {/*begin::Nav links*/}
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {/*begin::Nav item*/}
            <li className='nav-item'>
              <Link
                className='nav-link text-active-primary me-6'
                to={`/campaign/view/${campaign.id}`}
              >
                Overview
              </Link>
            </li>

            {
              <DropdownLink
                title='Contacts'
                items={[
                  {
                    name: 'View Contacts',
                    link: `/campaign/${campaign.id}/contact`,
                  },
                  (role === userTypes.Admin ||
                    role === userTypes.ClientManager ||
                    role === userTypes.CampaignManager) && {
                    name: 'Upload Contacts',
                    link: `/campaign/${campaign.id}/contact/upload`,
                  },
                ].filter(Boolean)}
              />
            }
            {/*begin::Nav item*/}
            <DropdownLink
              title='Data and Intelligence'
              items={[
                {
                  name: 'Intent Data',
                  link: `/campaign/data-intel/${campaign.id}/dashboard/intent`,
                },
                {
                  name: 'Intent and Engagement',
                  link: `/campaign/data-intel/${campaign.id}/dashboard/intent_and_engagement`,
                },
                {
                  name: 'Contact Data',
                  link: `/campaign/data-intel/${campaign.id}/dashboard/contact`,
                },
              ]}
            />
            {/*end::Nav item*/}
            <li className='nav-item'>
              <Link
                className='nav-link text-active-primary me-6'
                to={`/campaign/${campaign.id}/files`}
              >
                Files
              </Link>
            </li>
          </ul>
          {/*end::Nav links*/}
        </div>
        {/*end::Nav wrapper*/}
      </div>
    </div>
  )
}
